export default __webpack_public_path__ + "static/media/energisingchocolate-wide@2x.b3dfa67b.jpg";